import React, { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import ErrorBoundary from "./ErrorBoundary";
import MainSwitch from "./MainSwitch";
import {
  getAppBasePath,
  removeStaticLoader,
  adjustToAndroidKeyboard,
} from "./utils";
import useInteractionMonitoring from "./useInteractionMonitoring";
import { isAndroid } from "../common/utils/platform";
import { FeatureProvider } from "./features";

// adjust viewport when soft keyboard opens on android tablets
if (isAndroid()) {
  adjustToAndroidKeyboard();
}

/**
 * This should code split all the top-level routes and use only the most
 * minimal set of dependencies needed for operation (react, routing, critical
 * polyfills, etc)
 */
export default function AppMain() {
  useInteractionMonitoring();

  useEffect(() => {
    removeStaticLoader();
  }, []);

  return (
    <ErrorBoundary>
      <FeatureProvider>
        <BrowserRouter basename={getAppBasePath()}>
          <MainSwitch />
        </BrowserRouter>
      </FeatureProvider>
    </ErrorBoundary>
  );
}
